import PropTypes from 'prop-types';
import React from 'react';
import cx from 'classnames';
import styles from './EmbeddedHotspot.module.css';
export default function EmbeddedHotspot(_a) {
    var left = _a.left, top = _a.top, width = _a.width, height = _a.height, externalUrl = _a.externalUrl, viewport = _a.viewport, footerHeight = _a.footerHeight, headerHeight = _a.headerHeight, fullScreen = _a.fullScreen;
    var style = { left: left, top: top, width: width, height: height };
    if (fullScreen) {
        style = {
            left: 0,
            top: 0,
            width: viewport.width,
            height: viewport.height - footerHeight - headerHeight,
        };
    }
    return (React.createElement("iframe", { allow: "camera", allowFullScreen: true, allowTransparency: true, className: cx(styles.embeddedHotspot), frameBorder: 0, src: externalUrl, style: style }));
}
EmbeddedHotspot.propTypes = {
    left: PropTypes.number.isRequired,
    top: PropTypes.number.isRequired,
    width: PropTypes.number.isRequired,
    height: PropTypes.number.isRequired,
    externalUrl: PropTypes.string.isRequired,
    fullScreen: PropTypes.bool,
    footerHeight: PropTypes.number.isRequired,
    headerHeight: PropTypes.number.isRequired,
    viewport: PropTypes.shape({
        width: PropTypes.number,
        height: PropTypes.number,
    }),
};
